<template>
  <div class="app-qr-code" :style="wrapperStyle">
    <div ref="qrcode"></div>
    <img v-if="logoSrc" :src="logoSrc" alt="qrcode-logo" :style="logoStyle" />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

const levelMap = {
  L: QRCode.CorrectLevel.L,
  M: QRCode.CorrectLevel.M,
  Q: QRCode.CorrectLevel.Q,
  H: QRCode.CorrectLevel.H,
};

export default {
  name: "AppQrCode",
  props: {
    text: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 100,
    },
    margin: {
      type: Number,
      default: 0,
    },
    correctLevel: {
      type: [Number, String],
      default: "M",
    },
    colorDark: {
      type: String,
      default: "#000000",
    },
    colorLight: {
      type: String,
      default: "#ffffff",
    },
    backgroundColor: {
      type: String,
      default: "#ffffff",
    },
    backgroundDimming: {
      type: String,
      default: "",
    },
    logoSrc: {
      type: String,
      default: "",
    },
    logoScale: {
      type: Number,
      default: 0.2,
    },
    logoMargin: {
      type: Number,
      default: 0,
    },
    logoBackgroundColor: {
      type: String,
      default: "transparent",
    },
  },
  computed: {
    wrapperStyle() {
      return {
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 0,
        padding: `${this.margin}px`,
        backgroundColor: this.backgroundColor || this.backgroundDimming || "#ffffff",
      };
    },
    logoStyle() {
      const side = Math.max(0, Math.round(this.size * this.logoScale));
      return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: `${side}px`,
        height: `${side}px`,
        objectFit: "contain",
        backgroundColor: this.logoBackgroundColor,
        padding: `${this.logoMargin}px`,
        boxSizing: "content-box",
        pointerEvents: "none",
      };
    },
  },
  watch: {
    text() {
      this.renderQrCode();
    },
    size() {
      this.renderQrCode();
    },
    colorDark() {
      this.renderQrCode();
    },
    colorLight() {
      this.renderQrCode();
    },
    correctLevel() {
      this.renderQrCode();
    },
  },
  mounted() {
    this.renderQrCode();
  },
  methods: {
    resolveCorrectLevel(level) {
      if (typeof level === "number") {
        if (level === 0) return levelMap.L;
        if (level === 1) return levelMap.M;
        if (level === 2) return levelMap.Q;
        if (level === 3) return levelMap.H;
      }
      const key = String(level || "M").toUpperCase();
      return levelMap[key] || levelMap.M;
    },
    renderQrCode() {
      if (!this.$refs.qrcode) return;
      this.$refs.qrcode.innerHTML = "";
      if (!this.text) return;
      new QRCode(this.$refs.qrcode, {
        text: this.text,
        width: this.size,
        height: this.size,
        colorDark: this.colorDark,
        colorLight: this.colorLight,
        correctLevel: this.resolveCorrectLevel(this.correctLevel),
      });
    },
  },
};
</script>
